/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ninja-columns.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from 'ng-drag-drop/src/directives/draggable.directive';
import * as i3 from 'ng-drag-drop/src/services/ng-drag-drop.service';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../../../app/components/portal/settings-ninja/ninja-layers/ninja-columns/ninja-columns.component';
import * as i7 from '@angular/material/core';
import * as i8 from '@angular/material/dialog';
import * as i9 from 'ngx-toastr';
import * as i10 from '../../../../../../../app/common-services/appinfo.service';
import * as i11 from '../../../../../../../app/common-services/settings-ninja.service';
const styles_NinjaColumnsComponent:any[] = [i0.styles];
export const RenderType_NinjaColumnsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NinjaColumnsComponent,data:{}});
function View_NinjaColumnsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(1,(null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.displayName;
    _ck(_v,1,0,currVal_0);
  });
}
function View_NinjaColumnsComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'i',[['class',
      'glyphicons glyphicons-chevron-up'],['title','Move up']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.goUp((<any>_v.parent).context.index)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(null as any));
}
function View_NinjaColumnsComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'i',[['class',
      'glyphicons glyphicons-chevron-down'],['title','Move down']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.goDown((<any>_v.parent).context.index)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(null as any));
}
function View_NinjaColumnsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),27,'div',[['class',
      'column-item-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n				'])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),24,'div',[['class','column-item draggable-container'],
          ['draggable','']],[[8,'draggable',0]],[[(null as any),'onDragEnd'],[(null as any),
          'dragstart'],[(null as any),'dragend'],[(null as any),'mousedown'],[(null as any),
          'touchstart']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('dragstart' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,3).dragStart($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('dragend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,3).dragEnd($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('mousedown' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,3).mousedown($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('touchstart' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,3).mousedown($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('onDragEnd' === en)) {
          const pd_4:any = ((<any>_co.onDragEnd($event,_v.context.index)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(3,212992,(null as any),0,i2.Draggable,
      [i1.ElementRef,i1.Renderer2,i3.NgDragDropService,i1.NgZone],(null as any),{onDragEnd:'onDragEnd'}),
      (_l()(),i1.ɵted(-1,(null as any),['\n					'])),(_l()(),i1.ɵeld(5,0,(null as any),
          (null as any),1,'div',[['class','column-name']],[[8,'title',0]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(6,(null as any),
          ['\n						','\n					'])),(_l()(),i1.ɵted(-1,(null as any),['\n					'])),
      (_l()(),i1.ɵeld(8,0,(null as any),(null as any),8,'div',[['class','column-visib']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n						'])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),5,'input',[['type','checkbox']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,11).onChange($event.target.checked)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,11).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_v.context.$implicit.visib = $event)) !== false);
              ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_3:any = ((<any>_co.onToggleColumnVisib(_v.context.$implicit)) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(11,16384,(null as any),0,i4.CheckboxControlValueAccessor,
          [i1.Renderer2,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
          i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i4.CheckboxControlValueAccessor]),i1.ɵdid(13,671744,(null as any),0,i4.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i4.NgControl,(null as any),[i4.NgModel]),i1.ɵdid(15,
          16384,(null as any),0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n					'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n					'])),(_l()(),i1.ɵeld(18,0,(null as any),(null as any),7,'div',[['class',
          'column-seq']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n						'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NinjaColumnsComponent_3)),i1.ɵdid(21,
          16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n						'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NinjaColumnsComponent_4)),
      i1.ɵdid(24,16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n					'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n				'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n			']))],(_ck,_v) => {
    var _co:any = _v.component;
    _ck(_v,3,0);
    const currVal_10:any = i1.ɵinlineInterpolate(1,'visib-',_v.context.index,'');
    const currVal_11:any = _v.context.$implicit.disabled;
    const currVal_12:any = _v.context.$implicit.visib;
    _ck(_v,13,0,currVal_10,currVal_11,currVal_12);
    const currVal_13:any = (_v.context.index > 0);
    _ck(_v,21,0,currVal_13);
    const currVal_14:any = (_v.context.index < (_co.columns.length - 1));
    _ck(_v,24,0,currVal_14);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3).dragEnabled;
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.name,'');
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = _v.context.$implicit.name;
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = i1.ɵnov(_v,15).ngClassUntouched;
    const currVal_4:any = i1.ɵnov(_v,15).ngClassTouched;
    const currVal_5:any = i1.ɵnov(_v,15).ngClassPristine;
    const currVal_6:any = i1.ɵnov(_v,15).ngClassDirty;
    const currVal_7:any = i1.ɵnov(_v,15).ngClassValid;
    const currVal_8:any = i1.ɵnov(_v,15).ngClassInvalid;
    const currVal_9:any = i1.ɵnov(_v,15).ngClassPending;
    _ck(_v,10,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
  });
}
export function View_NinjaColumnsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'app-modal-title']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['Fields Visibility & Sequence'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(3,0,(null as any),
          (null as any),16,'div',[['class','app-modal-content']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n	'])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),13,'div',[['class',
          'column-table']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(7,
          0,(null as any),(null as any),4,'div',[['class','column-table-header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n			'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NinjaColumnsComponent_1)),i1.ɵdid(10,
          802816,(null as any),0,i5.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n		'])),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(13,
          0,(null as any),(null as any),4,'div',[['class','column-table-content']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n			'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NinjaColumnsComponent_2)),i1.ɵdid(16,
          802816,(null as any),0,i5.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n		'])),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵeld(21,0,(null as any),(null as any),12,'div',[['class','app-modal-footer']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵeld(23,0,(null as any),
          (null as any),9,'div',[['class','button-group']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n		'])),(_l()(),i1.ɵeld(25,0,(null as any),(null as any),2,'button',[['class',
          'button-general'],['md-raised-button','']],(null as any),[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i6.NinjaColumnsComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.cancel()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(26,16384,(null as any),0,i7.MdPrefixRejector,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['Cancel'])),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(29,
          0,(null as any),(null as any),2,'button',[['class','button-general'],['md-raised-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i6.NinjaColumnsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.apply()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(30,16384,(null as any),0,i7.MdPrefixRejector,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['Apply'])),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i6.NinjaColumnsComponent = _v.component;
    const currVal_0:any = _co.headers;
    _ck(_v,10,0,currVal_0);
    const currVal_1:any = _co.columns;
    _ck(_v,16,0,currVal_1);
  },(_ck,_v) => {
    var _co:i6.NinjaColumnsComponent = _v.component;
    const currVal_2:boolean = !_co.hasChanged;
    _ck(_v,29,0,currVal_2);
  });
}
export function View_NinjaColumnsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-ninja-columns',
      ([] as any[]),(null as any),(null as any),(null as any),View_NinjaColumnsComponent_0,
      RenderType_NinjaColumnsComponent)),i1.ɵdid(1,114688,(null as any),0,i6.NinjaColumnsComponent,
      [i8.MAT_DIALOG_DATA,i8.MatDialogRef,i1.ElementRef,i9.ToastrService,i10.AppinfoService,
          i11.SettingsNinjaService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NinjaColumnsComponentNgFactory:i1.ComponentFactory<i6.NinjaColumnsComponent> = i1.ɵccf('app-ninja-columns',
    i6.NinjaColumnsComponent,View_NinjaColumnsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/portal/settings-ninja/ninja-layers/ninja-columns/ninja-columns.component.ngfactory.ts